import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/', label: 'Accueil' },
    { path: '/services', label: 'Services' },
    { path: '/tarifs', label: 'Tarifs' },
    { path: '/blog', label: 'Blog' },
    { path: '/shop', label: 'Boutique' },
    { path: '/galerie', label: 'Galerie' },
    { path: '/a-propos', label: 'À Propos' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navigation-header">
      <div className="container" style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link to="/" className="navigation-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-institut-nina/artifacts/d1dwn4lv_1B38B2D4-E5C6-4A77-86AF-5639CAD654D6.png" 
              alt="Nina Care Institut" 
              style={{ height: '60px', width: 'auto' }}
            />
          </Link>

          {/* Desktop Menu */}
          <ul className="navigation-menu" style={{ display: window.innerWidth >= 1024 ? 'flex' : 'none' }}>
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`navigation-link ${isActive(item.path) ? 'active' : ''}`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>

          <div className="navigation-utilities">
            <a 
              href="tel:0984630327" 
              className="btn-secondary"
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <Phone size={16} />
              <span style={{ display: window.innerWidth >= 768 ? 'inline' : 'none' }}>
                09 84 63 03 27
              </span>
            </a>

            {/* Mobile Menu Toggle */}
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="mobile-menu-toggle"
              style={{ 
                display: window.innerWidth < 1024 ? 'block' : 'none',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '8px'
              }}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div 
            style={{
              display: window.innerWidth < 1024 ? 'block' : 'none',
              paddingTop: '20px'
            }}
          >
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {menuItems.map((item) => (
                <li key={item.path} style={{ marginBottom: '12px' }}>
                  <Link
                    to={item.path}
                    className={`navigation-link ${isActive(item.path) ? 'active' : ''}`}
                    onClick={() => setIsOpen(false)}
                    style={{ display: 'block' }}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
